import React from "react";
import Header from "@/components/marketing/Header";
import Footer from "@/components/marketing/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import MobileStickyCTA from "@/components/marketing/MobileStickyCTA";
import SEO, { LOCAL_BUSINESS_LD } from "@/components/SEO";

export default function MarketingLayout({ children }) {
    return (
        <div className="min-h-screen bg-bg text-ink">
            <SEO jsonLd={LOCAL_BUSINESS_LD} />
            <SmoothScroll />
            <Header />
            <main className="pb-16 md:pb-0">{children}</main>
            <MobileStickyCTA />
            <Footer />
        </div>
    );
}
